export default "__VITE_ASSET__Y3_kQNaH__"